<table class="table table bordered table-condensed downloads-table">
  <thead>
    <tr>
      <th [attr.colspan]="showPlatformColumn ? 4 : 3">&nbsp;</th>
      <th colspan="2">
        <mat-form-field appearance="fill" class="downloads-search-field">
          <mat-label>Search ISOs</mat-label>
          <input matInput id="downloads-isos-search" type="search" placeholder="Platform or name" [(ngModel)]="criteria" />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </th>
    </tr>
    <tr>
      <th><button mat-button type="button" class="table-sort-button" id="sort-isos-item" (click)="sortBy('item')">Item <mat-icon>{{ getSortIcon('item') }}</mat-icon></button></th>
      <th *ngIf="showPlatformColumn">
        <ng-container *ngIf="showPlatformFilter; else isosPlatformLabel">
        <button mat-button type="button" id="downloads-isos-platform-filter" [matMenuTriggerFor]="isosPlatformMenu">
          Platform
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #isosPlatformMenu="matMenu">
          <button mat-menu-item *ngFor="let platform of platforms" type="button" (click)="selectedPlatform = platform">{{ platform }}</button>
        </mat-menu>
        </ng-container>
        <ng-template #isosPlatformLabel>Platform</ng-template>
        <button mat-button type="button" class="table-sort-button" id="sort-isos-platform" (click)="sortBy('platform')">
          <mat-icon>{{ getSortIcon('platform') }}</mat-icon>
        </button>
      </th>
      <th><button mat-button type="button" class="table-sort-button" id="sort-isos-version" (click)="sortBy('version')">Version <mat-icon>{{ getSortIcon('version') }}</mat-icon></button></th>
      <th><button mat-button type="button" class="table-sort-button" id="sort-isos-size" (click)="sortBy('size')">Size <mat-icon>{{ getSortIcon('size') }}</mat-icon></button></th>
      <th><button mat-button type="button" class="table-sort-button" id="sort-isos-date" (click)="sortBy('date')">Date <mat-icon>{{ getSortIcon('date') }}</mat-icon></button></th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of displayedIsos">
      <td class="nowrap-cell">{{item.url.substring(item.url.lastIndexOf("/") + 1)}}</td>
      <td *ngIf="showPlatformColumn" class="nowrap-cell">{{item.platform}}</td>
      <td class="nowrap-cell">{{item.version}}</td>
      <td class="nowrap-cell">{{item.size | filesize}}</td>
      <td class="nowrap-cell">{{item.lastModified | date: "dd MMMM yyyy"}}</td>
      <td class="downloads-actions-cell">
        <button mat-icon-button color="primary" type="button" [id]="'download-iso-' + item.url.substring(item.url.lastIndexOf('/') + 1)" (click)="trackDownload(item)">
          <mat-icon>download</mat-icon>
        </button>
        <button *ngIf="item.sha256" mat-icon-button color="primary" type="button" [id]="'copy-sha256-iso-' + item.url.substring(item.url.lastIndexOf('/') + 1)" (click)="copyClipboard(item.sha256)" matTooltip="Copy SHA-256 fingerprint">
          <mat-icon>fingerprint</mat-icon>
        </button>
      </td>
    </tr>
  </tbody>
</table>
